import React, { Component } from "react";

class CompassBackPage extends Component {
  render() {
    return (
      <div className="roi-backpage-container">
        <img
          src="https://d2onbxnrte2nim.cloudfront.net/non-covers/062626_Compass-BackCover_1.jpg"
          className="roi-backpage-container-img"
          alt="COMPASS seller Back Page March 2026"
        />
      </div>
    );
  }
}

export default CompassBackPage;
